import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3ea2117c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3ea2117c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2117c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea2117c')) {
      api.createRecord('3ea2117c', component.options)
    } else {
      api.reload('3ea2117c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3ea2117c&scoped=true&", function () {
      api.rerender('3ea2117c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PN6tOCxVLPMQ/JS/comp/PopupBox.vue"
export default component.exports